const accessKeysES = {
    "view": {
        "title": "Claves de Acceso",
        "form": {
            "label": {
                "accessKeyId": "ID de Clave de Acceso",
                "secretAccessKey": "Clave de Acceso Secreta"
            },
            "button": {
                "hide": "Ocultar",
                "reveal": "Revelar"
            },
            "message": {
                "accessKeyIdCopied": "¡ID de Clave de Acceso copiada al portapapeles!",
                "secretAccessKeyCopied": "¡Clave de Acceso Secreta copiada al portapapeles!"
            }
        },
        "uploadInstructions": {
            "title": "Instrucciones",
            "step1": {
                "title": "Paso 1 - Descargar herramienta de carga",
                "description": "Descarga la herramienta <1>Cyberduck</1>."
            },
            "step2": {
                "title": "Paso 2 - Haz una copia de la Hoja de Carga y guarda el archivo Trigger",
                "descriptionPoint1": "Copia esta <1><strong>HOJA DE CÁLCULO</strong></1> a tu GOOGLE DRIVE.",
                "descriptionPoint2": "Guarda este <1><strong>ARCHIVO TRIGGER</strong></1> en tu computadora o almacenamiento en la nube."
            },
            "step3": {
                "title": "Paso 3 - Establece la conexión",
                "descriptionPoint1": "Abre la herramienta Cyberduck.",
                "descriptionPoint2": "En la esquina inferior izquierda haz clic en el icono +. (Agregar nuevo marcador).",
                "descriptionPoint3": "Introduce las siguientes credenciales:",
                "descriptionPoint4": "ID de Clave de Acceso: ",
                "descriptionPoint5": "Clave de Acceso Secreta: ",
                "descriptionPoint6": "Tu Carpeta S3: ",
                "descriptionPoint7": "Tu Ruta S3: ",
                "descriptionPoint8": "Sigue estos pasos:"
            },
            "step4": {
                "title": "Paso 4 - Completa los metadatos",
                "description": "Completa los metadatos de acuerdo a las instrucciones de nuestro Centro de Ayuda."
            },
            "step5": {
                "title": "Paso 5 - Archivos y Géneros",
                "descriptionPoint1": "Sube tu archivo <1>metadata.csv</1> y todos los archivos de audio <3>(.wav)</3> e <5>imagen (.jpg)</5>, <7> NO (.jpeg)</7>",
                "descriptionPoint2": "Los <strong>archivos JPG</strong> deben ser de <strong>3000x3000 px, tamaño máximo de archivo 4MB</strong>",
                "descriptionPoint3": "Los archivos de audio deben ser solo <strong>wav, 16 bit, 44.1 khz</strong>",
                "descriptionPoint4": "Los nombres de los archivos raíz deben ser una sola palabra",
                "descriptionPoint5": "<strong>IMPORTANTE:</strong> Ten en cuenta los <2><strong>Géneros de Danza ML</strong></2> y la coincidencia en las tiendas como Beatport."
            },
            "step6": {
                "title": "Paso 6 - Carga del Trigger",
                "description": "Después de que todos los archivos estén cargados, por favor sube este archivo trigger vacío <1>“last.zzz”</1>. Monitorea tu correo electrónico para cualquier notificación."
            },
            "step7": {
                "title": "Consejo - Prueba con nosotros antes de cargar",
                "description": "No dudes en contactar a nuestro equipo de soporte con cualquier pregunta sobre esta forma de creación de lanzamientos. Este es un proceso muy simple que se basa en tecnologías más robustas como AWS S3 y no depende de tecnologías de navegador. Sin embargo, requiere que tus metadatos sean 100 % precisos. El equipo de Music Link puede probar la carga de algunos lanzamientos para ti con tus metadatos para detectar posibles problemas."
            }
        }
    }
};

export default accessKeysES;